'use strict';
var React = require('react');
var appTypes = require('../../types/appTypes');
var linkHelper = require('../common/LinkHelper');

var Timer = React.createClass({

  propTypes: {
    interval: React.PropTypes.number
  },

  componentDidMount: function() {
    var self = this;
    this.delayFun = setTimeout(function() {
      self.parseInteractive();
    }, this.props.interval || 1000);
  },

  componentDidUpdate: function () {
    // clearTimeout(this.delayFun);
    // var self = this;
    // this.delayFun = setTimeout(function() {
    //   self.parseInteractive();
    // }, this.props.interval || 1000);
  },

  componentWillUnmount: function() {
    if (this.delayFun) {
      clearTimeout(this.delayFun);
    }
  },

  render: function () {
    return (<div/>);
  },

  parseInteractive: function() {
    var k;
    var actionData;

    if(this.props.interactiveData || this.props.links) {
      actionData = linkHelper.parseComInteractive(this.props)[0];
    }
    if (actionData) {
      k = appTypes.ActionResponseType.NONE;
      if (actionData.link) {
        k = appTypes.ActionResponseType.LINK;
        if(this.props.events && this.props.events.doSelfClick) {
          this.props.events.doSelfClick({}, this.props, k, 0);
        }
      }
    }
  }
});

module.exports = Timer;



// WEBPACK FOOTER //
// ./src/views/Components/Timer.jsx